import styled from 'styled-components';

interface ILoadingContainerProps {
  size: number;
  color: string;
}

interface IContentProps {
  padding: number;
}

export const Container = styled.div`
  position: fixed;
  margin: auto;
  bottom: 3rem;
  left: 0;
  width: 100%;
  height: 85vh;
  overflow: auto;
  background: transparent;
  z-index: 99998;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.section<IContentProps>`
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  padding: ${props => props.padding}px;
  border: none;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--cinza-escuro-5bits);
  > div {
    margin-top: 32px;
  }
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`;

export const LoadingContainer = styled.svg<ILoadingContainerProps>`
  animation: rotate 2s linear infinite;
  margin: 2.5px;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  & .path {
    stroke: ${props => props.color};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
